import { type BookkeepingStep } from './BookkeepingProgressionViewModel'

/**
 * Test ID for the bookkeeping step's primary action.
 */
export function getPrimaryActionTestId(step: BookkeepingStep) {
  switch (step) {
    case 'UnmanagedConfirmAccess':
      return 'confirm-unmanaged-access-button'
    case 'UnmanagedGrantAccess':
      return 'grant-bookkeeping-access-button'
    case 'StartBookkeeping':
      return 'start-bookkeeping-button'
    case 'BookkeepingInProgress':
      return 'complete-cycle-button'
    case 'StartNextCycle':
      return 'start-next-cycle-button'
    case 'BookkeepingCompleted':
      return 'complete-bookkeeping-job-button'
    default:
      return undefined
  }
}

/**
 * Test ID for the bookkeeping step's secondary action.
 */
export function getSecondaryActionTestId(step: BookkeepingStep) {
  switch (step) {
    case 'BookkeepingCompleted':
      return 'add-scope-change-button'
    default:
      return undefined
  }
}
